import cn from 'classnames';
import {FC, useEffect, useState} from 'react';
import {RegistrationCountry} from '../../../model';
import {CountryFlag} from './CountryFlag';
import {CountrySearchDrawer} from './CountrySearchDrawer';
import styles from './CountryDropdown.module.css';

type Props = {
	value: string | null;
	countryName?: string | null;
	onChange?: (oksmCode: string, country: RegistrationCountry) => void;
	placeholder?: string;
	drawerTitle?: string;
	disabled?: boolean;
	/** Кастомный клик по триггеру вместо открытия выбора страны. */
	onTriggerClick?: () => void;
	className?: string;
	labelSize?: 'default' | 'compact';
};

export const CountryDropdown: FC<Props> = ({
	value,
	countryName,
	onChange,
	placeholder = 'Выберите страну',
	drawerTitle = 'Выберите страну',
	disabled = false,
	onTriggerClick,
	className,
	labelSize = 'default',
}) => {
	const [open, setOpen] = useState(false);
	const [selectedCountry, setSelectedCountry] = useState<RegistrationCountry | null>(null);

	useEffect(() => {
		if (!value) {
			setSelectedCountry(null);
			return;
		}

		if (countryName) {
			setSelectedCountry({oksmCode: value, name: countryName});
		}
	}, [countryName, value]);

	const displayLabel = countryName ?? selectedCountry?.name ?? placeholder;
	const canOpenDrawer = !disabled && !onTriggerClick;

	const handleSelect = (country: RegistrationCountry) => {
		setSelectedCountry(country);
		onChange?.(country.oksmCode, country);
	};

	return (
		<>
			<div className={cn(styles.root, className)}>
				<button
					type="button"
					className={styles.trigger}
					disabled={disabled}
					onClick={() => {
						if (onTriggerClick) {
							onTriggerClick();
							return;
						}

						setOpen(true);
					}}
				>
					<CountryFlag
						country={selectedCountry ?? undefined}
						className={cn(styles.triggerFlag, !selectedCountry && styles.triggerFlag_muted)}
					/>
					<span
						className={cn(styles.triggerLabel, labelSize === 'compact' && styles.triggerLabel_compact)}
					>
						{displayLabel}
					</span>
				</button>
			</div>

			{canOpenDrawer ? (
				<CountrySearchDrawer
					open={open}
					title={drawerTitle}
					selectedOksmCode={value}
					onClose={() => setOpen(false)}
					onSelect={handleSelect}
				/>
			) : null}
		</>
	);
};
